import * as ss from 'superstruct';
import { OrgDto } from './org';

export const UserDto = ss.type({
  id: ss.number(),
  name: ss.string(),
  email: ss.string(),
  /**
   * Policy names as stored. A name dropped from `AuPolicy` outlives the code
   * that knew it and grants nothing (see `hasScope`).
   */
  policies: ss.array(ss.string()),
  superUser: ss.boolean(),
  /**
   * The organization whose data this user is currently viewing (the "active
   * org"). It is resolved per-request: by default the user's first accessible
   * org, or whichever accessible org they select via the active-org header.
   */
  org: OrgDto,
  /**
   * The full set of organizations this user may view/select between (their
   * memberships; for super users, all orgs). Only populated by
   * `GET /api/users/self` — undefined on the request-scoped user elsewhere.
   */
  organizations: ss.optional(ss.array(OrgDto)),
});

export type UserDto = ss.Infer<typeof UserDto>;
